import { useId, useRef } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useModalFocus } from '../hooks/useModalFocus';

export function RemoveMemberDrawer({ isOpen, onClose, member, onConfirm }) {
  const panelRef = useRef(null);
  const titleId = useId();
  const messageId = useId();
  // A destructive confirmation: focus lands on the first button, so Cancel comes first below.
  useModalFocus({ isOpen: isOpen && !!member, panelRef, onClose });

  if (!isOpen || !member) return null;

  const handleConfirm = () => {
    onConfirm(member.id);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/30 z-40"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Drawer */}
      <div
        ref={panelRef}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={messageId}
        tabIndex={-1}
        className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-50 max-w-[448px] mx-auto focus:outline-none"
      >
        <div className="px-6 py-6">
          {/* Handle bar */}
          <div className="flex justify-center mb-4">
            <div className="w-10 h-1 bg-gray-300 rounded-full" />
          </div>

          {/* Icon */}
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-[#FEF5F5] flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-[#9A4D41]" aria-hidden="true" />
            </div>
          </div>

          {/* Content */}
          <h2 id={titleId} className="text-xl text-center mb-3">Remove {member.name}?</h2>
          <p id={messageId} className="text-center text-[#5C5F6A] mb-6">
            {member.name} will lose access to your household's meal plans, shopping lists, and recipes.
            They can be re-invited later if needed.
          </p>

          {/* Actions */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 min-h-[48px] py-3 bg-white text-[#5F6B3F] font-medium border-2 border-[#5F6B3F] rounded-full hover:bg-[#F0F3EC] transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              className="flex-1 min-h-[48px] py-3 bg-[#9A4D41] text-white font-medium rounded-full hover:bg-[#843F35] transition-colors"
            >
              Remove member
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
